import React, { useEffect, useRef, useState } from 'react';
import IconComponent from '../../IconComponent/IconComponent';

interface TenantOptions {
  label: string;
  value: number;
}

interface SearchableSelectProps {
  options: TenantOptions[];
  value: string | undefined;
  onChange: (value: number) => void;
}

export const SearchableSelect: React.FC<SearchableSelectProps> = ({ options, value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef<HTMLDivElement>(null);

  const selectedOption = options.find((opt) => opt.value === Number(value));

  const filteredOptions = options.filter(
    (tenant) =>
      tenant.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
      String(tenant.value).toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
        setSearchTerm('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} style={{ position: 'relative', minWidth: 250 }}>
      <div
        onClick={() => setIsOpen((prev) => !prev)}
        className="flex items-center justify-between"
        style={{
          border: '1px solid #ccc',
          padding: '8px',
          cursor: 'pointer',
          borderRadius: '4px'
        }}>
        {selectedOption ? `${selectedOption.label}` : 'Wybierz...'}
        <span className="ml-2 text-gray-500">
          <IconComponent iconName="chevronDown" />
        </span>
      </div>

      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            border: '1px solid #ccc',
            borderTop: 'none',
            zIndex: 100,
            backgroundColor: '#fff',
            maxHeight: '200px',
            overflowY: 'auto'
          }}>
          <input
            type="text"
            placeholder="Szukaj..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ padding: '8px', width: '100%', boxSizing: 'border-box' }}
          />
          {filteredOptions.map((tenant) => (
            <div
              key={tenant.value}
              onClick={() => {
                onChange(tenant.value);
                setIsOpen(false);
                setSearchTerm('');
              }}
              style={{
                padding: '8px',
                cursor: 'pointer',
                borderTop: '1px solid #eee'
              }}>
              {tenant.label}
            </div>
          ))}
          {filteredOptions.length === 0 && (
            <div style={{ padding: '8px', color: '#999' }}>Brak wyników</div>
          )}
        </div>
      )}
    </div>
  );
};
